'use strict';

var Sugar = require('sugar-core'),
    _dateOptions = require('./var/_dateOptions');

module.exports = Sugar.Date.setOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/setOption.js
// module id = 282
// module chunks = 1